/**
 * İlaç alarm planı form ↔ API dönüşümleri ve istemci tarafı doğrulama.
 * Sunucu aynı kuralları ayrıca uygular (medication-plan/domain/schedule.js).
 */
export const DOSE_UNIT_OPTIONS = ["tablet", "kapsül", "ml", "damla", "ölçek", "puf", "adet"].map((u) => ({
  value: u,
  label: u,
}));

export const INSTRUCTION_OPTIONS = [
  { value: "none", label: "Talimat yok" },
  { value: "before_meal", label: "Yemekten önce" },
  { value: "after_meal", label: "Yemekten sonra" },
  { value: "with_meal", label: "Yemekle birlikte" },
  { value: "empty_stomach", label: "Aç karnına" },
];

export const DAY_OPTIONS = [
  { value: 1, label: "Pzt" },
  { value: 2, label: "Sal" },
  { value: 3, label: "Çar" },
  { value: 4, label: "Per" },
  { value: 5, label: "Cum" },
  { value: 6, label: "Cmt" },
  { value: 7, label: "Paz" },
];

const todayYmd = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" });

export const emptyForm = () => ({
  name: "",
  medicine: null,
  dose: 1,
  doseUnit: "tablet",
  instructions: "none",
  instructionsNote: "",
  times: ["09:00"],
  days: [],
  startDate: todayYmd(),
  endDate: null,
});

export const planToForm = (p) => ({
  name: p.name || "",
  medicine: p.medicine ? String(p.medicine._id || p.medicine) : null,
  dose: p.dose ?? 1,
  doseUnit: p.doseUnit || "tablet",
  instructions: p.instructions || "none",
  instructionsNote: p.instructionsNote || "",
  times: [...(p.schedule?.times || [])],
  days: [...(p.schedule?.days || [])],
  startDate: p.schedule?.startDate || todayYmd(),
  endDate: p.schedule?.endDate || null,
});

export const formToCreateBody = (f) => ({
  name: f.name.trim(),
  medicine: f.medicine || undefined,
  dose: Number(f.dose),
  doseUnit: f.doseUnit,
  instructions: f.instructions,
  instructionsNote: f.instructionsNote,
  schedule: { times: [...f.times].sort(), days: f.days, startDate: f.startDate, endDate: f.endDate || null },
});

const eq = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

/** Yalnız değişen alanlar — sunucu alan yetkisini alan bazında denetler. */
export const formToPatch = (plan, f) => {
  const before = planToForm(plan);
  const patch = {};
  for (const k of ["name", "medicine", "dose", "doseUnit", "instructions", "instructionsNote"]) {
    if (!eq(before[k], f[k])) patch[k] = k === "dose" ? Number(f[k]) : f[k];
  }
  const schedule = {};
  if (!eq([...before.times].sort(), [...f.times].sort())) schedule.times = [...f.times].sort();
  if (!eq([...before.days].sort(), [...f.days].sort())) schedule.days = [...f.days].sort();
  if (!eq(before.startDate, f.startDate)) schedule.startDate = f.startDate;
  if (!eq(before.endDate, f.endDate)) schedule.endDate = f.endDate || null;
  if (Object.keys(schedule).length) patch.schedule = schedule;
  return patch;
};

export const validateForm = (f) => {
  const e = {};
  if (!String(f.name || "").trim()) e.name = "İlaç adı zorunludur";
  if (!(Number(f.dose) > 0)) e.dose = "Doz 0'dan büyük olmalıdır";
  if (!f.times.length) e.times = "En az bir saat ekleyin";
  else if (new Set(f.times).size !== f.times.length) e.times = "Aynı saat tekrar edemez";
  if (!f.startDate) e.startDate = "Başlangıç tarihi zorunludur";
  if (f.endDate && f.startDate && f.endDate < f.startDate) e.endDate = "Bitiş tarihi başlangıçtan önce olamaz";
  return e;
};
